import { IProductBrand } from '../../../../../Product/DataStore/IProductBrand'
import { IProductCategory } from '../../../../../Product/DataStore/IProductCategory'

export const findProductBrandAndCategory = (
    brands: IProductBrand[],
    categoryId: number
): [IProductBrand, IProductCategory] | undefined => {
    for (const brand of brands) {
        const category = brand.categories.find((oneCategory) => oneCategory.id === categoryId)
        if (category) {
            return [brand, category]
        }
    }

    return undefined
}
